<template src="./index.html" />
<script>
import { validationMixin } from 'vuelidate';
import {
  required, email,
} from 'vuelidate/lib/validators';
import AWS from '@/services/AwsSdk';
import ConverEmailToLowerCase from '@/mixins/ConverEmailToLowerCase';
export default {
  name: 'ResetPassword',
  mixins: [validationMixin, ConverEmailToLowerCase],
  data: () => ({
    showPassword: false,
    errorResetPassword: null,
    pageObjName: 'reset',
    reset: {
      email: null,
    },
  }),
  validations: {
    reset: {
      email: {
        required, email,
      },
    },
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.reset.email.$dirty) return errors;
      if (!this.$v.reset.email.email) {
        errors.push('Invalid e-mail address');
      }
      if (!this.$v.reset.email.required) {
        errors.push('Please enter required value');
      }
      if (this.errorResetPassword) {
        errors.push(this.errorResetPassword);
      }
      return errors;
    },
  },
  created() {
  },
  methods: {
    resetPassword() {
      this.$v.reset.$touch();
      if (!this.$v.reset.$invalid) {
        this.$store.commit('spinner', true);
        AWS.forgotPassword(this.reset.email, this);
      }
    },
  },
};
</script>
<style scoped lang="scss" src="./index.scss"></style>
